import { BCMSRecord, Outlet, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import Classes from "model";
import "./styles.css";
/**
 * @function AdvancedAlertsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AdvancedAlertsPage
 */
export default function AdvancedAlertsPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const state = { data, ui };
    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui
    });
  
  return (
    <PageContainer className="advanced-alerts-page" state={ state } controller={ controller }>
        <PageContent/>
    </PageContainer>
  )
}

export const getDefaultPageData = () => ({
 
});

export const getDefaultPageUI = () => ({
  content: undefined
});

function PageContent(props) {
  const { data, ui } = useStateManager();
  const Component = ui.content;
  const compData = data.contentData;
  const compUI = data.contentUI;

  return (
    <PageContentView>
        <div className="flex-container flex-vertical page-widget-wrapper">
          <CenterContentContainer>
            <ContentHeaderView text="Advanced Alerts" />

            <div className="content-wrapper">
              { ui.content === undefined ? <Outlet /> : <Component data={ compData } ui={ compUI } /> }
            </div>
          </CenterContentContainer>
        </div>
    </PageContentView>
  );
}
